import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Service$SolvuuApi0 from "./service.bs.js";
import * as Blob_atd$SolvuuApi0 from "./blob_atd.bs.js";
import * as Blob_create_request_atd$SolvuuApi0 from "./blob_create_request_atd.bs.js";
import * as Blob_get_all_response_atd$SolvuuApi0 from "./blob_get_all_response_atd.bs.js";
import * as Blob_get_by_id_request_atd$SolvuuApi0 from "./blob_get_by_id_request_atd.bs.js";
import * as Blob_get_events_request_atd$SolvuuApi0 from "./blob_get_events_request_atd.bs.js";

function source(_param) {
  while (true) {
    var param = _param;
    var variant = param[0];

    if (variant !== -250904213) {
      if (variant >= 479410653) {
        _param = param[1][1].last_known_good_state;
        continue;
      } else {
        return param[1].source;
      }
    } else {
      return param[1][1].source;
    }
  }

  ;
}

var entity = "blobs";
var service = Service$SolvuuApi0.Get_by_id.service(entity);

function path(param) {
  return (
    /* :: */
    [entity,
    /* :: */
    [param.id,
    /* [] */
    0]]
  );
}

function body(ri) {
  return (
    /* `Json */
    [826371656, Curry._1(Blob_get_by_id_request_atd$SolvuuApi0.json_of_info, ri)]
  );
}

function info(path, body) {
  if (path && path[0] === "blobs") {
    var match = path[1];

    if (match && !match[1]) {
      if (typeof body === "number") {
        return Pervasives.failwith("Blob.get_by_id: invalid empty body");
      } else {
        return Curry._1(Blob_get_by_id_request_atd$SolvuuApi0.info_of_json, body[1]);
      }
    } else {
      return Service$SolvuuApi0.failwith_unexpected_path(service, path);
    }
  } else {
    return Service$SolvuuApi0.failwith_unexpected_path(service, path);
  }
}

var $$Request = {
  Json: Blob_get_by_id_request_atd$SolvuuApi0.Json,
  json_of_id: Blob_get_by_id_request_atd$SolvuuApi0.json_of_id,
  json_of_info: Blob_get_by_id_request_atd$SolvuuApi0.json_of_info,
  id_of_json: Blob_get_by_id_request_atd$SolvuuApi0.id_of_json,
  info_of_json: Blob_get_by_id_request_atd$SolvuuApi0.info_of_json,
  path: path,
  body: body,
  info: info
};
var Get_by_id = {
  entity: entity,
  service: service,
  $$Request: $$Request,
  $$Response:
  /* alias */
  0
};
var service$1 = Service$SolvuuApi0.Get_all.service(entity);

function path$1(param) {
  return Curry._1(Service$SolvuuApi0.Get_all.$$Request.path, entity);
}

function body$1(param) {
  return Service$SolvuuApi0.Get_all.$$Request.body;
}

function info$1(param, param$1) {
  return Service$SolvuuApi0.Get_all.$$Request.info;
}

var Get_all_Request = {
  path: path$1,
  body: body$1,
  info: info$1
};
var Get_all_Response = {
  ok_of_json: Blob_get_all_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Blob_get_all_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Blob_get_all_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Blob_get_all_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Blob_get_all_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Blob_get_all_response_atd$SolvuuApi0.json_of_not_found
};
var Get_all = {
  entity: entity,
  service: service$1,
  $$Request: Get_all_Request,
  $$Response: Get_all_Response
};
var service$2 = Service$SolvuuApi0.Create.service(entity);

function path$2(param) {
  return Curry._1(Service$SolvuuApi0.Create.$$Request.path, entity);
}

var body$2 = Curry._1(Service$SolvuuApi0.Create.$$Request.body, Blob_create_request_atd$SolvuuApi0.json_of_info);

var info$2 = Curry._1(Service$SolvuuApi0.Create.$$Request.info, Blob_create_request_atd$SolvuuApi0.info_of_json);

var $$Request$1 = {
  Json: Blob_create_request_atd$SolvuuApi0.Json,
  json_of_int64: Blob_create_request_atd$SolvuuApi0.json_of_int64,
  json_of_checksum: Blob_create_request_atd$SolvuuApi0.json_of_checksum,
  json_of_info: Blob_create_request_atd$SolvuuApi0.json_of_info,
  int64_of_json: Blob_create_request_atd$SolvuuApi0.int64_of_json,
  checksum_of_json: Blob_create_request_atd$SolvuuApi0.checksum_of_json,
  info_of_json: Blob_create_request_atd$SolvuuApi0.info_of_json,
  path: path$2,
  body: body$2,
  info: info$2
};
var Create = {
  entity: entity,
  service: service$2,
  $$Request: $$Request$1,
  $$Response:
  /* alias */
  0
};
var service$3 = Service$SolvuuApi0.Get_events.service(entity);

var path$3 = Curry._1(Service$SolvuuApi0.Get_events.$$Request.path, entity);

function body$3(param) {
  return Service$SolvuuApi0.Get_events.$$Request.body;
}

var info$3 = Curry._1(Service$SolvuuApi0.Get_events.$$Request.info, entity);

var $$Request$2 = {
  Json: Blob_get_events_request_atd$SolvuuApi0.Json,
  json_of_info: Blob_get_events_request_atd$SolvuuApi0.json_of_info,
  info_of_json: Blob_get_events_request_atd$SolvuuApi0.info_of_json,
  path: path$3,
  body: body$3,
  info: info$3
};
var Get_events = {
  entity: entity,
  service: service$3,
  $$Request: $$Request$2,
  $$Response:
  /* alias */
  0
};
var Json = Blob_atd$SolvuuApi0.Json;
var json_of_int64 = Blob_atd$SolvuuApi0.json_of_int64;
var json_of_id = Blob_atd$SolvuuApi0.json_of_id;
var json_of_event_id = Blob_atd$SolvuuApi0.json_of_event_id;
var json_of_s3_instructions = Blob_atd$SolvuuApi0.json_of_s3_instructions;
var json_of_s3_download = Blob_atd$SolvuuApi0.json_of_s3_download;
var json_of_s3_upload = Blob_atd$SolvuuApi0.json_of_s3_upload;
var json_of_instructions = Blob_atd$SolvuuApi0.json_of_instructions;
var json_of_denied_reason = Blob_atd$SolvuuApi0.json_of_denied_reason;
var json_of_processor_job = Blob_atd$SolvuuApi0.json_of_processor_job;
var json_of_storage = Blob_atd$SolvuuApi0.json_of_storage;
var json_of_checksum = Blob_atd$SolvuuApi0.json_of_checksum;
var json_of_created = Blob_atd$SolvuuApi0.json_of_created;
var json_of_started = Blob_atd$SolvuuApi0.json_of_started;
var json_of_available = Blob_atd$SolvuuApi0.json_of_available;
var json_of_validated = Blob_atd$SolvuuApi0.json_of_validated;
var json_of_completed = Blob_atd$SolvuuApi0.json_of_completed;
var json_of_corrupt = Blob_atd$SolvuuApi0.json_of_corrupt;
var json_of_failed = Blob_atd$SolvuuApi0.json_of_failed;
var json_of_state = Blob_atd$SolvuuApi0.json_of_state;
var json_of_t = Blob_atd$SolvuuApi0.json_of_t;
var int64_of_json = Blob_atd$SolvuuApi0.int64_of_json;
var id_of_json = Blob_atd$SolvuuApi0.id_of_json;
var event_id_of_json = Blob_atd$SolvuuApi0.event_id_of_json;
var s3_instructions_of_json = Blob_atd$SolvuuApi0.s3_instructions_of_json;
var s3_download_of_json = Blob_atd$SolvuuApi0.s3_download_of_json;
var s3_upload_of_json = Blob_atd$SolvuuApi0.s3_upload_of_json;
var instructions_of_json = Blob_atd$SolvuuApi0.instructions_of_json;
var denied_reason_of_json = Blob_atd$SolvuuApi0.denied_reason_of_json;
var processor_job_of_json = Blob_atd$SolvuuApi0.processor_job_of_json;
var storage_of_json = Blob_atd$SolvuuApi0.storage_of_json;
var checksum_of_json = Blob_atd$SolvuuApi0.checksum_of_json;
var created_of_json = Blob_atd$SolvuuApi0.created_of_json;
var started_of_json = Blob_atd$SolvuuApi0.started_of_json;
var available_of_json = Blob_atd$SolvuuApi0.available_of_json;
var validated_of_json = Blob_atd$SolvuuApi0.validated_of_json;
var completed_of_json = Blob_atd$SolvuuApi0.completed_of_json;
var corrupt_of_json = Blob_atd$SolvuuApi0.corrupt_of_json;
var failed_of_json = Blob_atd$SolvuuApi0.failed_of_json;
var state_of_json = Blob_atd$SolvuuApi0.state_of_json;
var t_of_json = Blob_atd$SolvuuApi0.t_of_json;
var $$Event =
/* alias */
0;
var Events =
/* alias */
0;
export { Json, json_of_int64, json_of_id, json_of_event_id, json_of_s3_instructions, json_of_s3_download, json_of_s3_upload, json_of_instructions, json_of_denied_reason, json_of_processor_job, json_of_storage, json_of_checksum, json_of_created, json_of_started, json_of_available, json_of_validated, json_of_completed, json_of_corrupt, json_of_failed, json_of_state, json_of_t, int64_of_json, id_of_json, event_id_of_json, s3_instructions_of_json, s3_download_of_json, s3_upload_of_json, instructions_of_json, denied_reason_of_json, processor_job_of_json, storage_of_json, checksum_of_json, created_of_json, started_of_json, available_of_json, validated_of_json, completed_of_json, corrupt_of_json, failed_of_json, state_of_json, t_of_json, $$Event, Events, source, entity, Get_by_id, Get_all, Create, Get_events };
/* service Not a pure module */